module.exports = __webpack_public_path__ + "img/propertycontrol1.2f9c89b7.png";